import { decodeJwt } from "jose";

export const decodeToken = (jwt: string) => {
  if (!jwt) {
    throw new Error("JWT token is required");
  }
  const payload = decodeJwt(jwt);

  return payload;
};
